import * as React from "react";
import Inspector from "./Inspector";
const delimiter = "%_%";
const ValueInspector = ({ value, small }) => {
    const [expandedPaths, setExpandedPaths] = React.useState([]);
    function onToggleExpand(path) {
        const pathString = path.join(delimiter);
        if (expandedPaths.includes(pathString)) {
            setExpandedPaths(expandedPaths.filter((currentPath) => currentPath !== pathString));
        }
        else {
            setExpandedPaths(expandedPaths.concat(pathString));
        }
    }
    return (React.createElement(Inspector, { delimiter: delimiter, value: value, expandedPaths: expandedPaths, onToggleExpand: onToggleExpand, small: small }));
};
export default ValueInspector;
//# sourceMappingURL=ValueInspector.js.map